export enum PageRoutes {
  HOME = "/",
  LOGIN = "/login",
  SET_PASSWORD = "/set-password",
  LOGOUT = "/logout",
  DASHBOARD = "/dashboard",
  APPLICATION = "/application",
  VARIATION = "/variation",
  VARIATIONFORM = "form",
  VARIATIONEDIT = "/variation/:id/edit",
  APPLICATIONFORM = "form",
  APPLICATIONEDIT = "/application/:id/edit",
  ENROLLMENT = "/enrollment",
  ENROLLMENTEDIT = "/enrollment/:id/edit",
  ENROLLMENTFORM = "form",
  NEW = "new",
  USERS = "/users",
  USERPROFILE = "/user-profile",
  UPDATEUSERS = "/users/update/:id",
  NEWUSER = "/new-user",
  PASSWORDCHANGE = "/user-password-change/:id",
  MAILVERIFICATION = "/email/verify/:id/:verification_token",
  FORGOTPASSWORD = "/forgot-password",
  RESETPASSWORD = "/reset-password",
  COURSES = "/courses",
  NEWCOURSE = "/course/new",
  UPDATECOURSE = "/course/update/:id",
  SHORTCOURSES = "/short-courses",
  SHORTCOURSEBOOK = "/short-course-book/:id",
  SHORTCOURSESORDER = "/short-courses-order",
  SHORTCOURSEORDERDETAIL = "/short-courses-order/:id",
  SHORTCOURSEORDERPDF = "/short-courses-pdf/:id",
  ROLES = "/roles",
  PERMISSIONSETTINGS = "/permission-settings",
  SHORTCOURSESBOOK = "/short-courses/:id/books",
  APPLIEDSHORTCOURSESPAY = "/applied-short-courses/pay",
  SHORTCOURSEORDERS = "/short-courses-orders",
  SHORTCOURSEORDERSPROSPECT = "prospect",
  SHORTCOURSEORDERSTENTATIVE = "tentative",
  SHORTCOURSEORDERSPROGRESSING = "progressing",
  SHORTCOURSEORDERSCOMPLETED = "completed",
  APPLIEDSHORTCOURSES = "/applied-short-courses",
  APPLIEDSHORTCOURSEDOCUMENT = "/applied-short-courses/:shortCourseId/document/:userId",
  PROFILE = "/profile",
  REGISTER = "/register",
  DEFER = "/defer",
  OVERSEAS = "/overseas",
  TRANSFER = "/transfer",
  V5ENROLLMENT = "/v5/enrollment",
  V5ENROLLMENTFORM = "/v5/enrollment-form",
  V5ENROLLMENTEDIT = "/v5/enrollment/:id/edit",

  REENROLLMENT = "/reenrollment",
  REENROLLMENTFORM = "form",
  REENROLLMENTEDIT = "/reenrollment/:id/edit",

  CHANGEOFADDRESS = "/change-of-address",
  CHANGEOFADDRESSFORM = "form",
  CHANGEOFADDRESSEDIT = "/change-of-address/:id/edit",

  VARIATIONOFCOURSE = "/variation-of-course",
  VARIATIONOFCOURSEFORM = "form",
  VARIATIONOFCOURSEEDIT = "/variation-of-course/:id/edit",

  INTERNALTRANSFER = "/internal-transfer",
  INTERNALTRANSFERFORM = "form",
  INTERNALTRANSFEREDIT = "/internal-transfer/:id/edit",

  STUDENTINTERVENTION = "/student-intervention",
  STUDENTINTERVENTIONFORM = "form",
  STUDENTINTERVENTIONEDIT = "/student-intervention/:id/edit",

  REQUESTOFINFORMATION = "/request-of-information",
  REQUESTOFINFORMATIONFORM = "form",
  REQUESTOFINFORMATIONEDIT = "/request-of-information/:id/edit",

  CREDITTRANSFER = "/credit-transfer",
  CREDITTRANSFERFORM = "form",
  CREDITTRANSFEREDIT = "/credit-transfer/:id/edit",

  DSRCENROLMENT = "/dsrc-enrolment",
  DSRCENROLMENTFORM = "form",
  DSRCENROLMENTEDIT = "/dsrc-enrolment/:id/edit",

  OVERSEASTRAVEL = "/overseas-travel",
  OVERSEASTRAVELFORM = "form",
  OVERSEASTRAVELEDIT = "/overseas-travel/:id/edit",

  CERTIFICATEAPPLICATION = "/certificate-application",
  CERTIFICATEAPPLICATIONFORM = "form",
  CERTIFICATEAPPLICATIONEDIT = "/certificate-application/:id/edit",
  TICKETS = "/tickets",
  TICKET_DETAIL = "/tickets/:id",
  NEW_TICKET = "/tickets/new",
  CHAT = "/chat",
  COMPLAINTSAPPEALS = "/complaints-appeals",
  COMPLAINTSAPPEALSFORM = "form",
  COMPLAINTSAPPEALSEDIT = "/complaints-appeals/:id/edit",

  FEEDBACK = "/feedback",

  DOCUMENTTYPES = "/document-types",
  DOCUMENTREPORT = "/document-report",

  NOTECATEGORIES = "/note-categories",
  SETTINGS = "/settings",
  PURCHASE_ORDER = '/purchase-order',
  INVENTORIES = '/inventories',
  CREATE_PURCHASE_ORDER = '/purchase-order/create',
  CREATE_INVENTORY = '/inventories/create'
}
